import { Box, Button, Checkbox, Grid, GridItem, Heading, Input, Table, Tbody, Td, Textarea, Th, Thead, Tr } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Permissions, useTableColors } from '../../Utils';
import { getRoleById, updateRole } from '../../api';

export default function EditRolePage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [selectedRole, setSelectedRole] = useState({ name: '', description: '', permissions: [] });
    const coolors = useTableColors();

    useEffect(() => {
        (async () => {
            const res = await getRoleById(id);
            if (res.success) setSelectedRole(res.data);
        })();
    }, [id]);

    const handleSelectAll = (categoryPermissions, isChecked) => {
        const updated = isChecked
            ? [...new Set([...selectedRole.permissions, ...Object.keys(categoryPermissions)])]
            : selectedRole.permissions.filter((p) => !Object.keys(categoryPermissions).includes(p));
        setSelectedRole({ ...selectedRole, permissions: updated });
    };

    const handlePermissionChange = (key, isChecked) => {
        const updated = isChecked
            ? [...selectedRole.permissions, key]
            : selectedRole.permissions.filter((p) => p !== key);
        setSelectedRole({ ...selectedRole, permissions: updated });
    };

    const handleSave = async () => {
        await updateRole(id, selectedRole);
        navigate('/roles');
    };

    return (
        <Box>
            <Heading size="lg" mb={4}>Edit Role</Heading>

            <Input
                mb={3}
                value={selectedRole.name}
                onChange={e => setSelectedRole({ ...selectedRole, name: e.target.value })}
                placeholder="Name"
            />
            <Textarea
                mb={6}
                value={selectedRole.description}
                onChange={e => setSelectedRole({ ...selectedRole, description: e.target.value })}
                placeholder="Description"
            />

            <Grid templateColumns="repeat(2, 1fr)" gap={6}>
                {Object.keys(Permissions).map((categoryKey) => {
                    const category = Permissions[categoryKey];
                    const allSelected = Object.keys(category.permissions).every((key) =>
                        selectedRole.permissions.includes(key)
                    );

                    return (
                        <GridItem key={categoryKey}>
                            <Heading size="md" mb={4}>
                                {category.name}
                                <Checkbox
                                    ml={3}
                                    isChecked={allSelected}
                                    onChange={e => handleSelectAll(category.permissions, e.target.checked)}
                                >
                                    <small>Select All</small>
                                </Checkbox>
                            </Heading>

                            <Table size="md" variant="simple">
                                <Thead bg={coolors.theadBg} color={coolors.textColor}>
                                    <Tr>
                                        <Th>Permission</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {Object.keys(category.permissions).map((key, i) => (
                                        <Tr
                                            key={key}
                                            borderBottom={`1px solid ${coolors.borderColor}`}
                                            bg={i % 2 === 0 ? coolors.rowBgEven : coolors.rowBgOdd}
                                            color={coolors.textColor}
                                            _hover={{ bg: coolors.rowHoverBg, color: "white" }}
                                        >
                                            <Td>
                                                <Checkbox
                                                    isChecked={selectedRole.permissions.includes(key)}
                                                    onChange={e => handlePermissionChange(key, e.target.checked)}
                                                    mr={3}
                                                />
                                                {(i + 1) + ". " + category.permissions[key]}
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </GridItem>
                    );
                })}
            </Grid>

            <Box mb={8}>
                <Button size="xs" colorScheme="green" mt={6} onClick={handleSave}>
                    Save
                </Button>
                <Button size="xs" ml={3} mt={6} onClick={() => navigate("/roles")}>
                    Cancel
                </Button>
            </Box>
        </Box>

    );
}
